import axiosInstance from "auth/FetchInterceptor";
import {
    EXPORT_MATERIALS_EXCEL,
    IMPORT_MATERIALS_GOOGLE_SHEET,
    EXPORT_PRODUCTS_EXCEL,
    IMPORT_PRODUCTS_GOOGLE_SHEET,
    EXPORT_PROCESSING_PRODUCTS,
    EXPORT_INVENTORY_PRODUCTS,
    IMPORT_WAREHOUSE_CHECK,
    IMPORT_WAREHOUSE_CHECK_EXCEL,
    EXPORT_WAREHOUSE_CHECK,
    IMPORT_EMPLOYEE,
    EXPORT_EMPLOYEE_EXCEL,
    EXPORT_UNIT_EXCEL,
    EXPORT_STOCK_DETAIL_EXCEL,
} from "constants/ApiConstant";

const ImportExportService = {};

ImportExportService.importMaterialsGoogleSheets = function (data) {
    return axiosInstance.post(IMPORT_MATERIALS_GOOGLE_SHEET, data);
};

ImportExportService.exportMaterialsExcel = function (params) {
    return axiosInstance.post(EXPORT_MATERIALS_EXCEL, params, {
        responseType: "blob",
    });
};

ImportExportService.importProductsGoogleSheets = function (data) {
    return axiosInstance.post(IMPORT_PRODUCTS_GOOGLE_SHEET, data);
};

ImportExportService.exportProductsExcel = function (params) {
    return axiosInstance.post(EXPORT_PRODUCTS_EXCEL, params, {
        responseType: "blob",
    });
};

ImportExportService.exportProcessingProducts = function (params) {
    return axiosInstance.post(EXPORT_PROCESSING_PRODUCTS, params, {
        responseType: "blob",
    });
};

ImportExportService.exportInventoryProducts = function (params) {
    return axiosInstance.post(EXPORT_INVENTORY_PRODUCTS, params, {
        responseType: "blob",
    });
};

ImportExportService.importWarehouseCheckGoogleSheets = function (data) {
    return axiosInstance.post(IMPORT_WAREHOUSE_CHECK, data);
};

ImportExportService.importWarehouseCheckExcel = function (formData) {
    return axiosInstance.post(IMPORT_WAREHOUSE_CHECK_EXCEL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

ImportExportService.exportWarehouseCheckExcel = function (params) {
    return axiosInstance.post(EXPORT_WAREHOUSE_CHECK, params, {
        responseType: "blob",
    });
};

ImportExportService.importEmployeesGoogleSheets = function (data) {
    return axiosInstance.post(IMPORT_EMPLOYEE, data);
};

ImportExportService.exportEmployeesExcel = function (params) {
    return axiosInstance.post(EXPORT_EMPLOYEE_EXCEL, params, {
        responseType: "blob",
    });
};

ImportExportService.exportUnitExcel = function (params) {
    return axiosInstance.post(EXPORT_UNIT_EXCEL, params, {
        responseType: "blob",
    });
};

ImportExportService.exportStockDetailExcel = function (params) {
    return axiosInstance.post(EXPORT_STOCK_DETAIL_EXCEL, params, {
        responseType: "blob",
    });
};

export default ImportExportService;